import { jsx } from 'panel';
import { EntryType, GroupEventBehaviors, RowLabelType, RowPrefixBehaviors } from 'common/widgets/query-entry-section/types';
import { QueryEntrySectionEl } from '../base/query-entry-section-el';
/**
 * QueryGroupedEntryRow renders a grouped event row (nested events)
 */

export function GroupedEntryRowEl(_ref) {
  let {
    section,
    entry,
    index
  } = _ref;
  return jsx(QueryEntrySectionEl, {
    attrs: Object.assign(Object.assign({}, section.helpers.getNestedSectionAttrs()), {
      'entry-type': EntryType.Event,
      elref: "subEntry",
      'row-label-prefix': section.helpers.getRowLabel(index),
      'row-label-prefix-behavior': RowPrefixBehaviors.FirstOnly,
      'row-label-type': RowLabelType.Alpha,
      'row-index': index,
      'row-index-toggleable': section.attr("row-index-toggleable"),
      'row-draggable': true,
      'group-event-behavior': GroupEventBehaviors.Append,
      entries: entry.event
    }),
    on: {
      update: ev => section.helpers.onGroupedSectionUpdate(index, ev),
      dropIntoGroup: section.helpers.onEntryStepDropIntoGroup,
      entryIndexLabelClicked: () => section.helpers.onEntryIndexLabelClicked(index)
    }
  });
}